module.exports = (Promise.resolve(__parcel__require__("./" + "module.30c25c82.fee69b18.js"))).then(() => parcelRequire('lg7QL'));